import { Box, Button, Typography, useMediaQuery } from '@material-ui/core';
import { Spin } from 'antd';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import moment from 'moment';
import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  ArrayField,
  ArrayInput,
  BooleanField,
  BooleanInput,
  ChipField,
  Create,
  DateInput,
  Edit,
  EditButton,
  Filter,
  FormDataConsumer,
  FunctionField,
  minValue,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceArrayInput,
  ReferenceField,
  ReferenceInput,
  required,
  SaveButton,
  SearchInput,
  SelectInput,
  SimpleFormIterator,
  SingleFieldList,
  TextField,
  TextInput,
  Toolbar,
  useShowController,
  useListContext,
  useRedirect,
  useNotify,
} from 'react-admin';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import CustomerCard from '../../components/CustomerCard';
import CustomTitle from '../../components/CustomTitle';
import ReferenceArrayChild from '../../components/ReferenceArrayChild';
import ReferenceChild from '../../components/ReferenceChild';
import ResponsiveAside from '../../components/ResponsiveAside';
import SaveButtonEnabledIfValid from '../../components/SaveButtonEnabledIfValid';
import dataProvider from '../../dataProvider';
import {
  getZ3PConfigValue,
  perPage,
  sortByKey,
  getServiceEntity, tracRudderStackEvent, currentPageInfo, trackFullStoryEvent,
} from '../../helper';
import PriceField from '../coupons/PriceField';
import TextFieldWithPrependAppend from '../TextFieldWithPrependAppend';
import AsideFilters from './AsideFilters';
import CreateSWUpsells from './CreateSWUpsells';
import { ExpandRecord } from './ExpandServices';
import HealthCheckButton from './HealthCheckButton';
import ScheduleChipWrapper from './ScheduleChipWrapper';
import SendRescheduleEmail from './SendRescheduleEmail';
import ServicesExpansionPanelEdit from './ServicesExpansionPanelEdit';
import ServicesFieldShow from './ServicesFieldShow';
import StatusChipField from './StatusChipField';
import TypographyField from './TypographyField';
import UnifiedRepairOrder from './UnifiedRepairOrder';
import UrlField from './UrlField';
import ListWithCSVImport from '../../components/ListWithCSVImport';
import BulkCancelAppointment from './BulkCancelAppointment';
import BulkConfirmAppointment from './BulkConfirmAppointment';
import TimeFieldInList from '../../components/TimeFieldInList';
import swExporter from '../../dataProvider/swExporter';
import AppointmentTimeField from '../../components/AppointmentTimeFieldInList';
import ActionButton from '../../components/ActionButton';
import './ScheduleWork.css';
import CustomEmptyComponent from '../../components/dataGridEmptyComponents';
import SourceImgField from './SourceImgField';
import { apiGet, apiPost } from '../../brainApi';
import { Client } from '@twilio/conversations';
import update from 'immutability-helper';
import SendIcon from '@material-ui/icons/Send';

const styles = {
  asidePadding: {
    padding: '10px 0 10px 15px',
  },
  labelStyle: {
    fontWeight: '600',
  },
  divide: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  serviceStyle: {
    height: 24,
  },
};
const useStyles = makeStyles({
  checkbox: {
    '& .MuiCheckbox-root': {
      borderRadius: '8px', // Adjust the border-radius value
    },
  },
});
const THIRTY_MINUTE_INTERVAL_IN_SECONDS = 30 * 60;

const ScheduledWorkFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

const SwBulkActionButtons = (props) => {
  const notify = useNotify();
  const [isShowSpinnerSendBulkSMS, setIsShowSpinnerSendBulkSMS] = useState(
    false,
  );
  const [token, setToken] = useState(null);
  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    getToken();
  }, []);

  const getToken = () => {
    apiGet('/twilio/chat-token').then((res) => {
      if (res.Status === 'Success') {
        setToken(res.Token);
      }
    });
  };

  const bulkSMSSend = () => {
    setIsShowSpinnerSendBulkSMS(true);
    const currentZ3PConfig = JSON.parse(
      // eslint-disable-next-line no-undef
      localStorage.getItem('z3pConfiguration'),
    );
    const payload = [];
    const scheduledWorkIds = props.selectedIds;
    Promise.all(
      scheduledWorkIds.map((scheduledWorkId) => {
        return apiGet(`/scheduled-work/${scheduledWorkId}`)
          .then((scheduledWorkRes) => {
            return scheduledWorkRes;
          })
          .catch((error) => {
            setIsShowSpinnerSendBulkSMS(false);
          });
      }),
    )
      .then((responses) => {
        responses.forEach((scheduledWorkRes) => {
          const chatFirstServiceName =
            scheduledWorkRes.services[0].display_name;
          const reviewUrl = `${currentZ3PConfig.booking_app_base_url}/google-review?utm_source=sms&utm_campaign=gmb_reviews`;
          const message =
            `Thank you for choosing us for your ${chatFirstServiceName}. We hope you're satisfied with the results.` +
            `\nPlease let us know your thoughts here ${reviewUrl}`;
          payload.push({
            customer_id: scheduledWorkRes.customer.customer_id,
            message,
            title: 'Route ETA Message',
          });
        });

        apiPost('/sms/bulk', {
          messages: payload,
        })
          .then((res) => {
            if (payload.length === res.num_messages_sent) {
              notify(
                `Sent ${res.num_messages_sent} message${res.num_messages_sent > 1 ? 's' : ''
                } successfully.`,
              );
            } else {
              const failedCount = payload.length - res.num_messages_sent;
              notify(
                `Sent ${res.num_messages_sent} message${res.num_messages_sent > 1 ? 's' : ''
                } successfully and ${failedCount} failed.`,
              );
            }
            for (let customer = 0; customer < payload.length; customer++) {
              apiGet(`/customer/${payload[customer].customer_id}?send_google_review_sms=true`).then((data) => {
                tracRudderStackEvent('Review_SMS_requested', {
                  proname: getZ3PConfigValue('z3p_client_name'),
                  installer_id: getZ3PConfigValue('st_installer_id'),
                  customer_email: data.email,
                  phone_number: data.phone,
                  First_name: data.first_name,
                  Last_name: data.last_name,
                  withAppointment: true,
                  page_information: {
                    path: currentPageInfo['PATH'],
                    url: currentPageInfo['URL'],
                    title: document.title,
                  },
                });
              });
            }
            setIsShowSpinnerSendBulkSMS(false);
          })
          .catch((error) => {
            setIsShowSpinnerSendBulkSMS(false);
          });
      })
      .catch((error) => {
        setIsShowSpinnerSendBulkSMS(false);
      });
  };
  const handleSendMessage = () => {
    trackFullStoryEvent('CTA_Request_Google_Calendar_SMS', {
      selected_count: props.selectedIds?.length || 0,
    });
    bulkSMSSend();
  };

  const schedulingSystem = getZ3PConfigValue('scheduling_system');
  const googleReviewUrl = getZ3PConfigValue('google_review_url');
  return (
    <Fragment>
      {/* <Typography variant="body2"> */}
      <b> Actions:</b>
      {/* </Typography> */}
      {googleReviewUrl && (
        <Button onClick={() => handleSendMessage()}
          className="cancel_btn"
          disabled={false}>
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google"
            style={{
              width: '20px',
              height: '20px',
              paddingRight: '6px',
            }}
          />
          <span>
            {isShowSpinnerSendBulkSMS
              ? 'Sending...'
              : 'Request Google Review via SMS'}{' '}
          </span>
          <SendIcon fontSize="small" />
        </Button>
      )}
      <BulkCancelAppointment label="Cancel Appointments" {...props} />
      <BulkConfirmAppointment label="Confirm Appointments" {...props} />
      {schedulingSystem === 'availability_windows' && (
        <SendRescheduleEmail label="Send Reschedule Email" {...props} />
      )}
    </Fragment>
  );
};
const RecordCount = ({ onEmpty }) => {
  const { total, isLoading } = useListContext();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (total === 0) {
    if (onEmpty) onEmpty(total);
  }

  if (onEmpty) onEmpty(total);
  return '';
};

const serviceLocations = getZ3PConfigValue('service_locations');
const hasWorkplaceServices = serviceLocations?.includes('workplace');
const hasShopServices = serviceLocations?.includes('shop');
const z3pClient = getZ3PConfigValue('z3p_client_name');
const schedulingSystem = getZ3PConfigValue('scheduling_system');
const isSkippingVehicle = getZ3PConfigValue('is_skipping_vehicle');
const isAcceptingTip = getZ3PConfigValue('is_accepting_tip');

export const ScheduledWorkList = (props) => {
  const redirect = useRedirect();
  const history = useHistory();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [totalRecord, setTotalRecords] = useState(0);

  const startTimeSource =
    schedulingSystem === 'availability_windows'
      ? 'planned_arrival_time'
      : 'confirmed_appointment_start_time';

  const vehicleRelatedFields = [
    <UrlField source="keyosk" sortable={false} />,
    <UrlField source="parking" sortable={false} />,
    <TextField source="box" />,
    <ReferenceField source="vehicle_id" reference="vehicle" allowEmpty>
      <ChipField source="display_name" />
    </ReferenceField>,
    <TextField source="key_exchange_note" />,
    <TextField source="vehicle_service_requirements_note" />,
    <TextField source="customer_tire_note" />,
  ];

  const classes = useStyles();
  // Callback to set empty state based on RecordCount
  const handleTotalRecords = (record) => {
    setTotalRecords(record);
  };

  const handleViewDetail = (record) => {
    redirect('show', '/scheduled-work', record.scheduled_work_id);
  };

  const handleChat = (record) => {
    history.push('/messages');
  };

  return (
    <ListWithCSVImport
      className="schedule_work_section"
      {...props}
      filters={
        isSmall ? (
          <ScheduledWorkFilter />
        ) : (
          <RecordCount onEmpty={handleTotalRecords} />
        )
      }
      filterDefaultValues={{
        start_date: moment()
          .subtract(15, 'days')
          .format('YYYY-MM-DD'),
        end_date: moment()
          .add(15, 'days')
          .format('YYYY-MM-DD'),
      }}
      sort={{ field: 'scheduled_work_id', order: 'DESC' }}
      perPage={50}
      bulkActionButtons={<SwBulkActionButtons />}
      // aside={!isSmall ? <AsideFilters /> : null}
      aside={<AsideFilters />}
      exporter={swExporter}
      showbreadcrumbs="true"
      showaddbutton="true"
      addbuttontitle="Add Appointment"
      currentbreadcrumb="Appointments"
      prevbreadcrumb="Customer Data"
    >
      {totalRecord > 0 ? (
        <ZippityDatagrid rowClick="show" className="schedule_list">
          <SourceImgField
            // source="st_order_id"
            source="source"
            label="Source"
            sortable={false}
          />
          {/* <ReferenceField source="customer_id" label="Name & Vehicle" reference="customer" link="show"> */}
          <FunctionField
            label="Name & Vehicle"
            render={(record) =>
              record ? (
                <div>
                  <span className="customer_name">
                    {record.customer.first_name} {record.customer.last_name}
                  </span>
                  <br />
                  <span className="vehicle_name">
                    {record.service_vehicle_name}
                  </span>
                </div>
              ) : null
            }
            sortBy="customer_id"
          />
          {/* </ReferenceField> */}
          <AppointmentTimeField label="Appointment time" sortBy="date" />
          <TextField source="modified_at" />
          <TextField source="scheduled_work_id" />

          <BooleanField source="is_handraise" />
          <TextField
            source="customer_location"
            label="Service Location"
            sortable={false}
          />
          {/* <TextField source="service_vehicle_name" /> */}
          <ArrayField source="services" sortable={false}>
            <SingleFieldList>
              <ChipField source="short_name" className="service_area" />
            </SingleFieldList>
          </ArrayField>
          <TextField source="admin_note" />
          <TextField source="st_order_id" />
          <TextField source="amazon_service_id" />
          <TextField source="service_order_id" />
          <PriceField
            record={{}}
            label="Price"
            source="total_taxed_price_dollars"
          />
          <StatusChipField source="status" />
          <PriceField record={{}} source="amount_paid_dollars" />
          {isAcceptingTip ? (
            [
              <PriceField record={{}} source="tip_amount_dollars" />,
              <BooleanField source="is_payment_held" />,
            ]
          ) : (
            <></>
          )}
          <ReferenceField
            source="payment_method_id"
            reference="payment-method"
            sortable
          >
            <TextField source="short_description" />
          </ReferenceField>
          <ReferenceField
            source="created_by_employee_id"
            reference="employee"
            sortable={false}
          >
            <TextField source="email_address" />
          </ReferenceField>
          <TextField source="waitlist_note" />
          <ScheduleChipWrapper
            source="upcoming_schedule_dates"
            sortable={false}
          />
          {/* source is only being given to these components because of https://github.com/fizix-io/ra-customizable-datagrid/issues/3 */}
          {/* Can't use source="unused" because apparently customizabledatagrid is linking them to the same button otherwise */}
          <HealthCheckButton source="health_check" sortable={false} />

          <ReferenceField
            source="employee_id"
            reference="employee"
            link="show"
            allowEmpty
          >
            <FunctionField
              render={(record) => `${record.first_name} ${record.last_name}`}
            />
          </ReferenceField>

          <BooleanField source="is_created_by_admin" />
          <TextField source="customer_note" />
          <TextField source="technician_note" />
          <TextField source="customer_diagnostic_note" />
          <TextField source="customer_schedule_note" />
          <TextField source="customer_home_additional_note" />
          <TextFieldWithPrependAppend source="tax_rate_percent" append="%" />
          {!isSkippingVehicle ? vehicleRelatedFields : <></>}
          <ActionButton
            onViewDetail={handleViewDetail}
            onChat={handleChat}
            sortable={false}
          />
        </ZippityDatagrid>
      ) : (
        <CustomEmptyComponent />
      )}
    </ListWithCSVImport>
  );
};

export const ROShow = (props) => {
  const { record } = useShowController(props);
  let filterServices;
  let filterRecord = record;
  if (record && record.services?.length > 0) {
    filterServices = record.services
      .filter((service) => service.status !== 'DELETED')
      .sort((a, b) => sortByKey(a, b, 'created_at'));
  }
  if (filterServices) {
    filterRecord = { ...record, services: filterServices };
  }
  if (record) {
    return <UnifiedRepairOrder {...props} record={filterRecord} />;
  }
  return null;
};

const getCustomerData = (customer_id) => {
  return dataProvider
    .getOne('customer', {
      id: customer_id,
    })
    .then((response) => {
      const { data } = response;
      const client_location_id = data.default_client_location_id;
      const { vehicles, addresses, is_fleet_user } = data;
      return { client_location_id, vehicles, addresses, is_fleet_user };
    });
};

const ScheduledWorkEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" />
  </Toolbar>
);

const ScheduledWorkAside = withStyles(styles)(({ record, classes }) => (
  <ResponsiveAside>
    <div className={classes.asidePadding}>
      <Typography variant="h6">Appointment Info</Typography>
      {record && (
        <div>
          <Typography variant="body2">
            <Box display="flex" alignItems="center">
              <Box pr={1}>Customer:</Box>
              <CustomerCard record={record} />
            </Box>
          </Typography>
          <Divider className={classes.divide} />
          <Typography variant="body2">
            <span className={classes.labelStyle}> Phone:</span>{' '}
            {record.customer.phone}
          </Typography>
          <Divider className={classes.divide} />
          <Typography variant="subtitle1">Vehicle</Typography>
          <ChipField
            label="Vehicle"
            record={record}
            source="vehicle.display_name"
          />
          <Divider className={classes.divide} />
          <Typography variant="body2">
            <span className={classes.labelStyle}> License Plate Number:</span>{' '}
            {record.vehicle.license_plate_number}
          </Typography>
          <Divider className={classes.divide} />
          <Typography variant="body2">
            <span className={classes.labelStyle}>State:</span>{' '}
            {record.vehicle.license_plate_state}
          </Typography>
        </div>
      )}
    </div>
  </ResponsiveAside>
));

export const ScheduledWorkEdit = (props) => {
  const [customerID, setCustomerID] = useState(null);
  const [customerAddresses, setCustomerAddresses] = useState([]);

  return (
    <Edit
      aside={<ScheduledWorkAside />}
      undoable={false}
      title={
        <CustomTitle
          title="resources.scheduled-work.title"
          subTitle="resources.scheduled-work.subtitle"
        />
      }
      {...props}
    >
      <ZippitySimpleForm
        toolbar={<ScheduledWorkEditToolbar />}
        submitOnEnter={false}
      >
        <TypographyField label="Booking" />
        <TextInput
          source="planned_arrival_time"
          type="time"
          validate={[required()]}
          inputProps={{
            step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
          }}
        />
        <TextInput
          source="planned_departure_time"
          type="time"
          validate={[required()]}
          inputProps={{
            step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
          }}
        />
        <DateInput source="date" />
        <FormDataConsumer source="is_handraise">
          {({ formData, ...rest }) => (
            <div>
              <BooleanInput source="is_handraise" />
              {!formData.date && (
                <TextInput
                  multiline
                  source="waitlist_note"
                  validate={[required()]}
                  fullWidth
                  {...rest}
                />
              )}
            </div>
          )}
        </FormDataConsumer>
        <ReferenceInput
          source="service_vehicle_id"
          reference="service-vehicle"
          sort={{ field: 'name', order: 'ASC' }}
          filter={{ is_active: true }}
          perPage={perPage}
          label={getServiceEntity()}
        >
          <ReferenceChild
            {...props}
            optionText="name"
            source="service_vehicle_id"
          />
        </ReferenceInput>
        {(hasWorkplaceServices || hasShopServices) && (
          <ReferenceInput
            source="client_location_id"
            reference="client-location"
            perPage={perPage}
            allowEmpty
            label={hasWorkplaceServices ? 'Client location' : 'Shop'}
          >
            <ReferenceChild
              {...props}
              optionText="short_name"
              source="client_location_id"
            />
          </ReferenceInput>
        )}
        {hasWorkplaceServices && (
          <FormDataConsumer source="keyosk_id">
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="keyosk_id"
                reference="keyosk"
                filter={{ client_location_id: formData.client_location_id }}
                {...rest}
              >
                <ReferenceChild
                  {...props}
                  optionText="name"
                  source="keyosk_id"
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
        )}
        {hasWorkplaceServices && <TextInput source="box" />}
        {hasWorkplaceServices && (
          <FormDataConsumer source="parking_id">
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="parking_id"
                reference="parking"
                filter={{ client_location_id: formData.client_location_id }}
                {...rest}
              >
                <ReferenceChild
                  {...props}
                  optionText="name"
                  source="parking_id"
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
        )}
        <FormDataConsumer>
          {({ formData }) => {
            if (formData.customer_id && formData.customer_id !== customerID) {
              setCustomerID(formData.customer_id);
              getCustomerData(formData.customer_id).then((r) => {
                setCustomerAddresses(r.addresses);
              });
            }
          }}
        </FormDataConsumer>
        <SelectInput
          optionText="one_line_human_readable_address"
          choices={customerAddresses}
          source="customer_address_id"
          allowEmpty
        />
        <FormDataConsumer>
          {({ formData }) => (
            <SelectInput
              source="status"
              choices={[
                { id: 'scheduled', name: 'Scheduled' },
                ...(formData.st_order_id ? [] : [{ id: 'keys_available', name: 'Keys Available' }]),
                { id: 'finished', name: 'Finished' },
                { id: 'cancelled', name: 'Cancelled' },
                ...(formData.st_order_id ? [] : [{ id: 'suggested', name: 'Suggested' }]),
              ]}
            />
          )}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.status === 'cancelled' && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <SelectInput
                  source="cancellation_reason"
                  choices={[
                    {
                      id: 'Date or Time Conflict',
                      name: 'Date or Time Conflict',
                    },
                    {
                      id: 'Serviced Car Elsewhere',
                      name: 'Serviced Car Elsewhere',
                    },
                    { id: 'Other', name: 'Other:' },
                  ]}
                  validate={required()}
                  {...rest}
                />
                <TextInput
                  source="cancellation_reason_details"
                  validate={
                    formData.cancellation_reason === 'Other' ? required() : null
                  }
                  fullWidth
                  {...rest}
                />
              </div>
            )
          }
        </FormDataConsumer>
        {z3pClient === 'zippity' && <BooleanInput source="is_fleet_service" />}
        <BooleanInput source="is_created_by_admin" disabled />
        <TypographyField label="Notes" />
        <TextInput multiline source="customer_note" fullWidth />
        <TextInput source="admin_note" fullWidth />
        <TextInput source="customer_tire_note" fullWidth />
        <TextInput source="technician_note" fullWidth />

        <TextInput source="customer_diagnostic_note" fullWidth />
        <TextInput source="customer_schedule_note" fullWidth />
        <TextInput source="key_exchange_note" fullWidth />
        <TextInput source="vehicle_service_requirements_note" fullWidth />
        <TextInput source="customer_home_additional_note" fullWidth />
        <TypographyField label="Services" />
        <ArrayInput source="services" fullWidth>
          <SimpleFormIterator disableAdd>
            <ServicesExpansionPanelEdit />
          </SimpleFormIterator>
        </ArrayInput>
        <ReferenceArrayInput
          source="service_offering_ids"
          reference="service-offering"
          options={{ fullWidth: true }}
          perPage={perPage}
          sort={{ field: 'short_name', order: 'ASC' }}
        >
          <ReferenceArrayChild
            {...props}
            optionText="short_name"
            source="service_offering_ids"
          />
        </ReferenceArrayInput>
        <CreateSWUpsells float="right" />
        <TypographyField
          label="If you want to edit the prices/names of these new services, please save
          and then click edit again."
          variant="subtitle1"
        />

        <TypographyField label="Financials" />
        <ReferenceInput
          source="coupon_code"
          reference="coupon"
          perPage={perPage}
          sort={{ field: 'coupon_code', order: 'ASC' }}
          allowEmpty
        >
          <ReferenceChild
            {...props}
            optionText="coupon_code"
            source="coupon_code"
          />
        </ReferenceInput>
        <NumberInput
          source="custom_discount_amount_dollars"
          formatOnBlur
          format={(v) => Number(v)}
          validate={[minValue(0)]}
        />
        <TextInput source="custom_discount_reason" />
        <TextInput source="referrer_code" />
      </ZippitySimpleForm>
    </Edit>
  );
};

const ScheduledWorkCreateToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButtonEnabledIfValid />
  </Toolbar>
);

// https://marmelab.com/react-admin/CreateEdit.html#global-validation
const validateScheduledWork = (values) => {
  const errors = {};
  if (!values.client_location_id && !values.customer_address_id) {
    errors.client_location_id = 'resources.scheduled-work.validation.location';
    errors.customer_address_id = 'resources.scheduled-work.validation.location';
  }
  return errors;
};

export const ScheduledWorkCreate = (props) => {
  const [clientLocationID, setClientLocationID] = useState(null);
  const [customerVehicles, setCustomerVehicles] = useState([
    { id: 1, display_name: 'Please Select a Customer First', disabled: true },
  ]);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [isFleetUser, setIsFleetUser] = useState(null);
  const [customerID, setCustomerID] = useState(null);

  const { location } = props;
  const { state } = location;
  if (state) {
    const { record } = state;
    const {
      vehicles,
      client_location_id,
      service_vehicle_id,
      vehicle,
      is_fleet_user,
    } = record;
    // If coming from a customer, a vehicle, or a scheduled work: return a prefilled form with fields instead of inputs for customer data
    return (
      <Create {...props}>
        <ZippitySimpleForm
          redirect="show"
          validate={validateScheduledWork}
          toolbar={<ScheduledWorkCreateToolbar />}
        >
          <DateInput
            source="date"
            defaultValue={moment().format('YYYY-MM-DD')}
          />
          <FormDataConsumer source="is_handraise">
            {({ formData, ...rest }) => (
              <div>
                <BooleanInput source="is_handraise" />
                {!formData.date && (
                  <TextInput
                    multiline
                    source="waitlist_note"
                    validate={[required()]}
                    fullWidth
                    {...rest}
                  />
                )}
              </div>
            )}
          </FormDataConsumer>
          {/* The following fields should ideally be also defaulted to the customer's last sw values */}
          <TextInput
            source="planned_arrival_time"
            type="time"
            inputProps={{
              step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
            }}
            defaultValue="09:00"
            validate={[required()]}
          />
          <TextInput
            source="planned_departure_time"
            type="time"
            inputProps={{
              step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
            }}
            defaultValue="17:00"
            validate={[required()]}
          />
          <ReferenceInput
            source="service_vehicle_id"
            reference="service-vehicle"
            sort={{ field: 'name', order: 'ASC' }}
            filter={{ is_active: true }}
            perPage={perPage}
            defaultValue={service_vehicle_id}
            validate={[required()]}
            label={getServiceEntity()}
          >
            <ReferenceChild
              {...props}
              optionText="name"
              source="service_vehicle_id"
              validate={[required()]}
            />
          </ReferenceInput>
          <ReferenceField
            label="First Name"
            reference="customer"
            source="customer_id"
          >
            <TextField source="first_name" />
          </ReferenceField>
          <ReferenceField
            label="Last Name"
            reference="customer"
            source="customer_id"
          >
            <TextField source="last_name" />
          </ReferenceField>
          <ReferenceField
            label="Email"
            reference="customer"
            source="customer_id"
          >
            <TextField source="email" />
          </ReferenceField>
          {(hasWorkplaceServices || hasShopServices) && (
            <ReferenceInput
              source="client_location_id"
              reference="client-location"
              perPage={perPage}
              allowEmpty
              label={hasWorkplaceServices ? 'Client location' : 'Shop'}
            >
              <ReferenceChild
                {...props}
                optionText="short_name"
                source="client_location_id"
              />
            </ReferenceInput>
          )}
          {hasWorkplaceServices && (
            <ReferenceInput
              source="keyosk_id"
              reference="keyosk"
              filter={{
                client_location_id,
              }}
            >
              <ReferenceChild {...props} optionText="name" source="keyosk_id" />
            </ReferenceInput>
          )}
          {hasWorkplaceServices && (
            <ReferenceInput
              source="parking_id"
              reference="parking"
              filter={{
                client_location_id,
              }}
            >
              <ReferenceChild
                {...props}
                optionText="name"
                source="parking_id"
              />
            </ReferenceInput>
          )}
          {customerAddresses && customerAddresses.length !== 1 && (
            <SelectInput
              optionText="one_line_human_readable_address"
              choices={customerAddresses}
              source="customer_address_id"
              allowEmpty
              validate={
                !(hasWorkplaceServices || hasShopServices) && [required()]
              }
            />
          )}
          {customerAddresses && customerAddresses.length === 1 && (
            <SelectInput
              optionText="one_line_human_readable_address"
              choices={customerAddresses}
              source="customer_address_id"
              allowEmpty
              defaultValue={customerAddresses[0].id}
              validate={
                !(hasWorkplaceServices || hasShopServices) && [required()]
              }
            />
          )}
          {vehicles.length !== 1 && (
            <SelectInput
              defaultValue={vehicle}
              optionText="display_name"
              choices={vehicles}
              source="vehicle_id"
              validate={[required()]}
            />
          )}
          {vehicles.length === 1 && (
            <SelectInput
              optionText="display_name"
              choices={vehicles}
              source="vehicle_id"
              validate={[required()]}
              defaultValue={vehicles[0].id}
            />
          )}
          {z3pClient === 'zippity' && (
            <BooleanInput
              defaultValue={is_fleet_user}
              label="Fleet Service?"
              source="is_fleet_service"
              options={{
                checkedIcon: <LocalShippingIcon />,
              }}
            />
          )}
          <ReferenceInput
            source="coupon_code"
            reference="coupon"
            perPage={perPage}
            sort={{ field: 'coupon_code', order: 'ASC' }}
            allowEmpty
          >
            <ReferenceChild
              {...props}
              optionText="coupon_code"
              source="coupon_code"
            />
          </ReferenceInput>
          <ServicesFieldShow />
          <ReferenceArrayInput
            source="service_offering_ids"
            reference="service-offering"
            options={{ fullWidth: true }}
            perPage={perPage}
            sort={{ field: 'short_name', order: 'ASC' }}
          >
            <ReferenceArrayChild
              {...props}
              optionText="short_name"
              source="service_offering_ids"
            />
          </ReferenceArrayInput>
          <FormDataConsumer>
            {({ formData }) => (
              <RadioButtonGroupInput
                source="status"
                defaultValue="scheduled"
                choices={[
                  { id: 'scheduled', name: 'Scheduled' },
                  ...(formData.st_order_id ? [] : [{ id: 'suggested', name: 'Suggested' }]),
                ]}
              />
            )}
          </FormDataConsumer>
          <BooleanInput source="is_created_by_admin" defaultValue disabled />
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.customer_id && formData.customer_id !== customerID) {
                setCustomerID(formData.customer_id);
                getCustomerData(formData.customer_id).then((r) => {
                  setClientLocationID(r.client_location_id);
                  setCustomerAddresses(r.addresses);
                });
              }
            }}
          </FormDataConsumer>
        </ZippitySimpleForm>
      </Create>
    );
  }

  // Else coming from the basic create scheduled_work flow: return a generic form with values only prefilled after the user searches by customer_email
  return (
    <Create {...props}>
      <ZippitySimpleForm
        redirect="show"
        validate={validateScheduledWork}
        toolbar={<ScheduledWorkCreateToolbar />}
      >
        <ReferenceInput
          reference="customer"
          source="customer_id"
          validate={[required()]}
        >
          <ReferenceChild {...props} optionText="email" source="customer_id" />
        </ReferenceInput>
        <DateInput source="date" defaultValue={moment().format('YYYY-MM-DD')} />
        <FormDataConsumer source="is_handraise">
          {({ formData, ...rest }) => (
            <div>
              <BooleanInput source="is_handraise" />
              {!formData.date && (
                <TextInput
                  multiline
                  source="waitlist_note"
                  validate={[required()]}
                  fullWidth
                  {...rest}
                />
              )}
            </div>
          )}
        </FormDataConsumer>
        <TextInput
          source="planned_arrival_time"
          type="time"
          inputProps={{
            step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
          }}
          defaultValue="09:00"
          validate={[required()]}
        />
        <TextInput
          source="planned_departure_time"
          type="time"
          inputProps={{
            step: THIRTY_MINUTE_INTERVAL_IN_SECONDS,
          }}
          defaultValue="17:00"
          validate={[required()]}
        />
        <ReferenceInput
          source="service_vehicle_id"
          reference="service-vehicle"
          sort={{ field: 'name', order: 'ASC' }}
          filter={{ is_active: true }}
          perPage={perPage}
          validate={[required()]}
          label={getServiceEntity()}
        >
          <ReferenceChild
            {...props}
            optionText="name"
            source="service_vehicle_id"
            validate={[required()]}
          />
        </ReferenceInput>
        <FormDataConsumer source="form-data-consumer">
          {({ formData }) => {
            if (formData.customer_id && formData.customer_id !== customerID) {
              setCustomerID(formData.customer_id);
              getCustomerData(formData.customer_id).then((r) => {
                setClientLocationID(r.client_location_id);
                setCustomerVehicles(r.vehicles);
                setCustomerAddresses(r.addresses);
                setIsFleetUser(r.is_fleet_user);
              });
            }
          }}
        </FormDataConsumer>

        <FormDataConsumer>
          {({ formData }) => (
            <RadioButtonGroupInput
              source="status"
              defaultValue="scheduled"
              choices={[
                { id: 'scheduled', name: 'Scheduled' },
                ...(formData.st_order_id ? [] : [{ id: 'suggested', name: 'Suggested' }]),
              ]}
            />
          )}
        </FormDataConsumer>
        <BooleanInput source="is_created_by_admin" defaultValue disabled />

        <ReferenceArrayInput
          resource="scheduled-work"
          source="service_offering_ids"
          reference="service-offering"
          options={{ fullWidth: true }}
          perPage={perPage}
          sort={{ field: 'short_name', order: 'ASC' }}
        >
          <ReferenceArrayChild
            {...props}
            optionText="short_name"
            source="service_offering_ids"
          />
        </ReferenceArrayInput>

        <ReferenceInput
          source="coupon_code"
          reference="coupon"
          perPage={perPage}
          sort={{ field: 'coupon_code', order: 'ASC' }}
          allowEmpty
        >
          <ReferenceChild
            {...props}
            optionText="coupon_code"
            source="coupon_code"
          />
        </ReferenceInput>

        {clientLocationID && (hasWorkplaceServices || hasShopServices) && (
          <ReferenceInput
            source="client_location_id"
            reference="client-location"
            defaultValue={clientLocationID}
            allowEmpty
            label={hasWorkplaceServices ? 'Client location' : 'Shop'}
          >
            <ReferenceChild
              {...props}
              optionText="short_name"
              source="client_location_id"
            />
          </ReferenceInput>
        )}

        {clientLocationID && hasWorkplaceServices && (
          <ReferenceInput
            source="keyosk_id"
            reference="keyosk"
            filter={{
              client_location_id: clientLocationID,
            }}
          >
            <ReferenceChild {...props} optionText="name" source="keyosk_id" />
          </ReferenceInput>
        )}

        {clientLocationID && hasWorkplaceServices && (
          <ReferenceInput
            source="parking_id"
            reference="parking"
            filter={{
              client_location_id: clientLocationID,
            }}
          >
            <ReferenceChild {...props} optionText="name" source="parking_id" />
          </ReferenceInput>
        )}

        {customerAddresses && customerAddresses.length > 0 && (
          <SelectInput
            optionText="one_line_human_readable_address"
            choices={customerAddresses}
            source="customer_address_id"
            allowEmpty
          />
        )}

        {isFleetUser !== null && z3pClient === 'zippity' && (
          <BooleanInput
            defaultValue={isFleetUser}
            label="Fleet Service?"
            source="is_fleet_service"
            options={{
              checkedIcon: <LocalShippingIcon />,
            }}
          />
        )}

        <SelectInput
          optionText="display_name"
          choices={customerVehicles}
          source="vehicle_id"
          validate={[required()]}
        />
      </ZippitySimpleForm>
    </Create>
  );
};
